import { useCallback, useState } from 'react';
import { Collapse } from '@mui/material';
import classNames from 'classnames';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { SearchField } from 'app/agriculture/infobox/common/SearchField/SearchField';
import { Button } from 'app/agriculture/components/Button/Button';
import { NoteButtonFilters } from './NoteButtonFilters';
import './NoteListHeader.scss';

interface NoteListHeaderProps {
    onButtonFilterChange: (buttonFilterIds: string[]) => void;
    onTextFilterChange: (searchTerm: string) => void;
}

export function NoteListHeader({ onTextFilterChange, onButtonFilterChange }: NoteListHeaderProps) {
    const routeActions = useRouteActions();
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [textFilter, setTextFilter] = useState('');
    const [buttonFilterIds, setButtonFilterIds] = useState<string[]>([]);

    const handleTextFilterChange = useCallback(
        (textFilter: string) => {
            setTextFilter(textFilter);
            onTextFilterChange(textFilter);
        },
        [onTextFilterChange],
    );

    const handleButtonFilterChange = useCallback(
        (buttonFilterIds: string[]) => {
            setButtonFilterIds(buttonFilterIds);
            onButtonFilterChange(buttonFilterIds);
        },
        [onButtonFilterChange],
    );

    return (
        <div className="NoteListHeader">
            <div className="NoteListHeader__top">
                <Button
                    text="Add Note"
                    startIcon="add"
                    onClick={() => {
                        routeActions.create('Note');
                    }}
                />
                <Button
                    id="open-search-button"
                    className={classNames('SearchButton', {
                        'SearchButton--selected': isSearchOpen,
                    })}
                    startIcon="search"
                    variant="textonly"
                    onClick={() => {
                        setIsSearchOpen(!isSearchOpen);
                    }}
                    text={!isSearchOpen ? 'Search' : 'Exit Search'}
                />
            </div>
            <Collapse in={isSearchOpen}>
                <div className="NoteListHeader__search-tray">
                    <SearchField textFilter={textFilter} onChange={handleTextFilterChange} />
                    <NoteButtonFilters
                        filterIds={buttonFilterIds}
                        onFilterIdsChange={handleButtonFilterChange}
                    />
                </div>
            </Collapse>
        </div>
    );
}
